var inactivity = (function(self){
    self.inactivity = 0; 
    self.maxTime = 15; 
    self.currentMaxTime = 15; 
    self.isPlayingPhase = false;
    self.callback = null;

    self.update = function(delta)
    {
        if(self.isPlayingPhase) self.inactivity += delta;
        if (self.inactivity >= self.currentMaxTime)
        {
            self.inactivity = 0;
            self.currentMaxTime = self.maxTime*2;
            self.callback();
        }
    };

    self.resetMaxTime = function()
    {
        self.currentMaxTime = self.maxTime;
    };

    self.reset = function(playingPhase)
    {
        if(playingPhase === null) playingPhase = true;
        self.inactivity = 0;
        self.isPlayingPhase = playingPhase;
    };

    return self;
}(inactivity = inactivity || {}));
